




import { Component, Vue, Prop } from 'vue-property-decorator';

@Component({ components: {} })
export default class CustomAcknowledgment extends Vue {
  @Prop() public content: string;
}
